import React from 'react'
import { Button } from 'components'
import { SampleUpload } from './SampleUpload'
import { useTranslation } from 'react-i18next'

interface props {
  setSteps: () => void
  onPrev: () => void
  dataSource: [][]
  type: string
}

export const ConfirmData = (props: props): JSX.Element => {
  const { setSteps, onPrev, dataSource, type } = props
  const { t } = useTranslation(['onboarding'])

  return (
    <div>
      <SampleUpload type={type} dataSource={dataSource} />
      <div className='f-onboarding-modal'>
        <Button variants='secondary' className='confirm-btn' onClick={onPrev}>
          {t('onboarding:confirmation.back')}
        </Button>
        <Button
          type='submit'
          variants='primary'
          className='confirm-btn'
          onClick={setSteps}
        >
          {t('onboarding:confirmation.confirm')}
        </Button>
      </div>
    </div>
  )
}
